import {
  Flex,
  Text,
  MenuItemOptionProps,
  MenuItemOption,
  forwardRef,
} from '@cdl/heartbeat-react';
import { FrozenMarker } from '../../../features/diagnostic/components/FrozenMarker';
import { DateTime } from 'luxon';

type Props = {
  expertName: string;
  updatedAt: string;
  immutable: boolean;
} & MenuItemOptionProps;

export const CustomMenuItemOption = forwardRef<Props, 'button'>(
  ({ expertName, updatedAt, immutable, ...rest }, ref) => {
    return (
      <MenuItemOption ref={ref} {...rest}>
        <Flex title={expertName} justify='space-between' align='center'>
          <Text noOfLines={1} flex='1'>
            {expertName}
          </Text>
          {updatedAt && (
            <Text fontSize='xs' px='s'>
              {DateTime.fromISO(updatedAt).toLocaleString()}
            </Text>
          )}
          {immutable && <FrozenMarker />}
        </Flex>
      </MenuItemOption>
    );
  },
);

// https://github.com/chakra-ui/chakra-ui/issues/2545
// https://github.com/chakra-ui/chakra-ui/issues/5011
CustomMenuItemOption.id = 'MenuItemOption';
